// cleanup_convert_to_typescript_file_GENERICS
// cleanup_remove_external_libraries_GENERICS

import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { uniqueId } from 'lodash';

import { CheckboxRadio, CheckboxRadioGroup } from '@glu/form-components';

import useLocale from 'components/useLocale';
import { getAllowedTransferDates } from 'api/transfers/service';
import { unsubscribeComponent } from 'utils/unsubscribeComponent';

import useStyles from './BeforeAfterDayRadio.styles';

const subscriptions = {
  calendar$: null
};

const AFTER = 'after';

const FUTURE_DATED_FIELD = 'futureDated';

export const BeforeAfterDayRadioComponent = ({
  componentType,
  config,
  futureDated,
  onChange,
  setInitial
}) => {
  const [processOnHolidays, setProcessOnHolidays] = useState(
    config ? config.processOnHolidays : true
  );
  const [processOnNonBusinessDays, setProcessOnNonBusinessDays] = useState(
    config ? config.processOnNonBusinessDays : true
  );
  const id = useRef(null);
  const { wrapper } = useStyles();
  const locale = useLocale();

  const updateDate = () => {
    subscriptions.calendar$ = getAllowedTransferDates().subscribe(
      ({ processOnHolidays: holidays, processOnNonBusinessDays: businessDays }) => {
        setProcessOnNonBusinessDays(businessDays);
        setProcessOnHolidays(holidays);
      }
    );
  };

  const handleChange = (_name, value) => {
    const futureDated = value === AFTER;
    onChange(FUTURE_DATED_FIELD, futureDated);
  };

  useEffect(() => {
    id.current = uniqueId();

    if (!config) {
      updateDate();
    }

    if (setInitial && futureDated === null) {
      onChange(FUTURE_DATED_FIELD, false);
    }
    return () => unsubscribeComponent(subscriptions);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (processOnHolidays && processOnNonBusinessDays) {
    return null;
  }

  return (
    <div className={wrapper} data-qa="beforeAfter-selector">
      <CheckboxRadioGroup groupLabel={locale[`beforeradio.message.${componentType}`]}>
        <CheckboxRadio
          name={`${FUTURE_DATED_FIELD}${id.current}`}
          type="radio"
          labelText={locale['beforeradio.prior']}
          htmlValue="prior"
          onChange={handleChange}
          checked={!futureDated}
          data-qa="prior"
          aria-label={locale[`beforeradio.aria.${componentType}.prior`]}
        />
        <CheckboxRadio
          name={`${FUTURE_DATED_FIELD}futureDated${id.current}`}
          type="radio"
          labelText={locale['beforeradio.after']}
          htmlValue="after"
          onChange={handleChange}
          checked={futureDated}
          data-qa="after"
          aria-label={locale[`beforeradio.aria.${componentType}.after`]}
        />
      </CheckboxRadioGroup>
    </div>
  );
};

BeforeAfterDayRadioComponent.defaultProps = {
  futureDated: false,
  onChange: /* istanbul ignore next */ () => {},
  setInitial: false,
  componentType: 'transfer',
  config: undefined
};

BeforeAfterDayRadioComponent.propTypes = {
  futureDated: PropTypes.bool,
  onChange: PropTypes.func,
  setInitial: PropTypes.bool,
  componentType: PropTypes.string,
  config: PropTypes.shape({
    processOnHolidays: PropTypes.bool,
    processOnNonBusinessDays: PropTypes.bool
  })
};

export default BeforeAfterDayRadioComponent;
